"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetImages = exports.deleteManyImages = exports.deletedOneImage = exports.updatedManyImages = exports.updatedOneImage = exports.gotManyImages = exports.gotOneImage = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneImage = gotOne;
exports.gotManyImages = gotMany;
exports.updatedOneImage = updatedOne;
exports.updatedManyImages = updatedMany;
exports.deletedOneImage = deletedOne;
exports.deleteManyImages = deleteMany;
exports.resetImages = reset;
//# sourceMappingURL=actions.js.map